import { AdditionalInfoImpl } from './additional-info-impl';
import { Expose } from 'class-transformer';

export class CAN1Status extends AdditionalInfoImpl {
  @Expose({ name: 'break_pads' })
  breakPads: string;

  @Expose({ name: 'break_pad1' })
  breakPad1: string;

  @Expose({ name: 'break_pad2' })
  breakPad2: string;

  @Expose({ name: 'break_pad3' })
  breakPad3: string;

  @Expose({ name: 'break_pad4' })
  breakPad4: string;

  @Expose({ name: 'break_pad5' })
  breakPad5: string;

  @Expose({ name: 'break_pad6' })
  breakPad6: string;

  @Expose({ name: 'break_pad7' })
  breakPad7: string;

  @Expose({ name: 'break_pad8' })
  breakPad8: string;

  @Expose({ name: 'can_speed' })
  canSpeed: number;

  @Expose({ name: 'coolant_temperature' })
  coolantTemperature: number;

  @Expose({ name: 'dpf_light' })
  dpfLight: number;

  @Expose({ name: 'dpf_regeneration' })
  dpfRegeneration: number;

  @Expose({ name: 'engine_speed' })
  engineSpeed: number;

  @Expose({ name: 'gear' })
  gear: number;

  static getGearText(gear: number | null): string {
    let text = null;
    if (gear != null) {
      if (gear == 0 || gear == 1)
        text = '' + gear;
      else if (gear == 251)
        text = 'P';
      else if (gear == 255)
        text = 'b.d.';
      else if (gear == 125)
        text = 'N';
      else if (gear > 125)
        text = 'D' + (gear - 125);
      else if (gear < 125)
        text = 'R';
    }
    if (text == null)
      text = '' + gear;
    return text;
  }
}
